import React, {FC} from 'react';
import classNames from 'classnames';
import {Markdown} from 'components/Markdown';
import {useCtxConfig} from 'pages/dashboard/components/FirstLook/context';
import {Screen} from 'pages/dashboard/components/FirstLook/Screens/Screen';
import {FactoidConfig} from 'pages/dashboard/components/FirstLook/types';

import * as styles from './styles.module.scss';

export const Factoid: FC = () => {
	const {screen} = useCtxConfig() as {screen?: FactoidConfig};
	if (screen?.type !== 'factoid') {
		return null;
	}

	return (
		<Screen>
			<div className={classNames({
				[styles.factoid]: true,
				[styles.invert]: screen.illustration.layout === 'Top',
			})}>
				<div className={styles.text}>
					<Markdown markdown={screen.text} />
				</div>
				<div className={styles.image}>
					<img src={screen.illustration.url} />
				</div>
			</div>
		</Screen>
	);
};
